/** Что из отказа можно показать родителю.
 *
 *  Правило одно и проверяемое: родителю доходит только то, что написано
 *  ДЛЯ него, то есть по-русски. Своих отказов это касается в первую
 *  очередь — «это не файл выгрузки тренажёра», «в файле нет профиля» —
 *  и они единственная подсказка, по которой взрослый поймёт, что не так с
 *  файлом. Чужие английские строки от Dexie и `JSON.parse` не говорят ему
 *  ничего, а выглядят как поломка приложения.
 *
 *  Мерка — язык, а не класс ошибки, и это не хитрость. Обещание здесь
 *  ровно такое: «английский технический текст до родителя не доходит».
 *  Мерка по классу проверяла бы другое обещание — «отказ наш», — а наши
 *  отказы бросаются обычным `Error`, неотличимым от чужого.
 *
 *  Второе, что здесь закрыто: обработчик не бросает. Прежде в трёх местах
 *  стояло `String((cause as Error).message ?? …)`, и на `null` это бросало
 *  прямо внутри обработчика отказа промиса. Отрисовку такой бросок не
 *  роняет — он уходит в промис, — поэтому экрана «Что-то сломалось»
 *  родитель не увидел бы. Он увидел бы замерший экран: `setBusy(false)`
 *  ниже по обработчику уже не исполнится, кнопка останется серой, а
 *  объяснения не будет вовсе. */
const КИРИЛЛИЦА = /[Ѐ-ӿ]/;

export function текстОтказа(cause: unknown, запасной: string): string {
  const message = cause instanceof Error ? cause.message : '';
  return КИРИЛЛИЦА.test(message) ? message : запасной;
}
